module.exports = __webpack_public_path__ + "media/news/karte_gohlis1-f80861a7.webp";